import { render } from "./HeroiconsSolidWifi.vue?vue&type=template&id=bf3b1d00"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidWifi.vue"]])

export default __exports__